import { pluralize } from "@sellar-io/common";

const generateProductItemName = (productItemProperties: {
  containerType: string;
  volume: number;
  unit: string;
}) => {
  const { containerType, volume, unit } = productItemProperties;
  return `${volume}${unit} ${pluralize(containerType, 2)}`;
};

export const CaseSizeRuleStatus = ({
  caseSizeRules,
  enforceCaseSizeRules,
}: {
  caseSizeRules: {
    containerType: string;
    unit: string;
    volume: number;
    quantity: number;
  }[];
  enforceCaseSizeRules: boolean;
}) => {
  if (!caseSizeRules.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-2">
      {caseSizeRules.map((rule) => {
        const productName = generateProductItemName(rule);
        const key =
          rule.containerType + rule.quantity + rule.unit + rule.volume;

        // case size rule enforced

        if (enforceCaseSizeRules) {
          return (
            <div
              className="flex items-center rounded-lg border border-solid border-indigo-200 bg-indigo-100 p-3"
              key={key}
            >
              <div className="inline text-indigo-800">
                You are <b>required</b> to order {productName} in full cases of{" "}
                {rule.quantity}
              </div>
            </div>
          );
        }

        // case size rule not enforced

        return (
          <div
            className="flex items-center rounded-lg border border-solid border-indigo-200 bg-indigo-100 p-3"
            key={key}
          >
            <div className="inline text-indigo-800">
              You are <b>advised</b> to order {productName} in full cases of{" "}
              {rule.quantity}
            </div>
          </div>
        );
      })}
    </div>
  );
};
